<template>
	<main class="main rules-page">
		<div class="main-wrapper">
			<section class="rules-hero">
				<div class="rules-hero__glow"></div>

				<div class="rules-hero__inner _cnt">
					<div class="rules-hero__content">
						<div class="rules-hero__subtitle _subtitle">
							{{ $t('КОДЕКС СЕРВЕРА') }}
						</div>

						<h1 class="rules-hero__title _h2">
							{{ $t('Правила BloxNest') }}
						</h1>

						<p class="rules-hero__description">
							{{
								$t(
									'Незнание правил не освобождает от ответственности. Регистрируясь на сервере, вы соглашаетесь со всеми перечисленными ниже правилами.',
								)
							}}
						</p>
					</div>
				</div>
			</section>

			<section class="rules-content">
				<div class="rules-content__inner _cnt">
					<div class="rules-list">
						<article
							v-for="(group, index) in ruleGroups"
							:key="group.id"
							class="rule-card"
						>
							<header class="rule-card__header">
								<div
									:class="[
										'rule-card__number',
										`rule-card__number_${group.color}`,
									]"
								>
									<span>
										{{ formatNumber(index + 1) }}
									</span>
								</div>

								<h2 class="rule-card__title">
									{{ $t(group.title) }}
								</h2>
							</header>

							<ul class="rule-card__list">
								<li
									v-for="(rule, ruleIndex) in group.rules"
									:key="ruleIndex"
									class="rule-card__item"
								>
									<span class="rule-card__bullet"></span>

									<span class="rule-card__text">
										{{ $t(rule) }}
									</span>
								</li>
							</ul>
						</article>
					</div>

					<div class="rules-notice">
						<p class="rules-notice__text">
							{{
								$t(
									'Наказания: предупреждение → мут → временный бан → перманентный бан. Апелляции рассматриваются через форму в разделе «Контакты» в течение 14 дней.',
								)
							}}
						</p>
					</div>
				</div>
			</section>
		</div>
	</main>
</template>

<script>
export default {
	name: 'Rules',

	data() {
		return {
			ruleGroups: [
				{
					id: 'general-behaviour',
					color: 'green',
					title: 'Общее поведение',
					rules: [
						'Уважайте других игроков: оскорбления, травля и токсичность в чате запрещены.',
						'Никакой рекламы сторонних серверов, сайтов и услуг.',
						'Ники и скины не должны содержать оскорбительный или провокационный контент.',
					],
				},
				{
					id: 'fair-play',
					color: 'yellow',
					title: 'Честная игра',
					rules: [
						'Читы, X-Ray, дюпы и любые модификации, дающие преимущество, запрещены и ведут к перманентному бану.',
						'Об обнаруженных ошибках сервера необходимо сообщать администрации, а не использовать их.',
						'Мультиаккаунты для обхода наказаний запрещены.',
					],
				},
				{
					id: 'builds-and-territory',
					color: 'blue',
					title: 'Постройки и территории',
					rules: [
						'Гриферство и разрушение чужих построек запрещены во всех режимах, кроме анархии.',
						'Запрещено строить вплотную к чужим базам без согласия владельца.',
						'Ловушки, убивающие игроков на нейтральной территории, запрещены.',
					],
				},
				{
					id: 'economy-and-trading',
					color: 'red',
					title: 'Экономика и торговля',
					rules: [
						'Продажа игровых ценностей за реальные деньги между игроками запрещена.',
						'Обман при обмене или торговле наказывается баном торговли.',
						'Попытка отменить платёж через банк после получения предмета приводит к блокировке аккаунта.',
					],
				},
			],
		};
	},

	methods: {
		goBack() {
			if (this.$parent && typeof this.$parent.back === 'function') {
				this.$parent.back();
				return;
			}

			this.$router.go(-1);
		},

		formatNumber(number) {
			return String(number).padStart(2, '0');
		},
	},
};
</script>

<style scoped lang="scss">
.main-wrapper {
	max-width: 840px;
	margin: 0 auto;
}

.rules-page {
	position: relative;
	min-height: 50vh;
}

/* Hero */

.rules-hero {
	position: relative;
	padding: 44px 16px 34px;
	overflow: hidden;
}

.rules-hero__glow {
	position: absolute;
	top: -220px;
	left: 50%;
	width: 700px;
	height: 440px;
	transform: translateX(-10%);

	background: radial-gradient(
		circle,
		rgba(33, 193, 126, 0.045) 0%,
		rgba(33, 193, 126, 0) 70%
	);

	pointer-events: none;
}

.rules-hero__inner {
	position: relative;
	display: flex;
	align-items: flex-start;
	gap: 18px;
	max-width: 880px;
}

.rules-hero__back {
	flex: 0 0 40px;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 2px;
	padding: 0;

	background: var(--heavy-metal);
	border: 1px solid var(--outer-space);
	border-radius: 9px;

	box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.025),
		inset -2px -2px 0 rgba(0, 0, 0, 0.24);

	transition: background-color 0.25s ease, border-color 0.25s ease,
		transform 0.25s ease;

	@media (any-hover: hover) {
		&:hover {
			background: var(--outer-space);
			border-color: var(--31);
			transform: translateX(-3px);
		}
	}
}

.rules-hero__back-icon {
	display: block;
	width: 17px;
	height: 17px;
}

.rules-hero__content {
	min-width: 0;
}

.rules-hero__subtitle {
	margin-bottom: 15px;
	text-transform: uppercase;
}

.rules-hero__title {
	margin: 0;
}

.rules-hero__description {
	margin-top: 17px;
	font-family: var(--font-1);
	font-size: 15px;
	font-weight: 400;
	line-height: 24px;

	color: var(--mantle);
}

.rules-content {
	padding: 14px 16px 100px;
}

.rules-list {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.rule-card {
	position: relative;
	padding: 29px 27px;
	background: #141a17;
	border: 1px solid #202a25;
	border-radius: 6px;

	box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.018),
		inset -2px -2px 0 rgba(0, 0, 0, 0.18);

	transition: all 0.3s ease 0s;

	@media (any-hover: hover) {
		&:hover {
			border-color: rgba(33, 193, 126, 0.28);
			transform: translateY(-1px);
		}
	}
}

.rule-card__header {
	display: flex;
	align-items: center;
	gap: 14px;
	margin-bottom: 10px;
}

.rule-card__number {
	position: relative;
	flex: 0 0 40px;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: var(--font-3);
	font-size: 11px;
	font-weight: 700;
	line-height: 13px;

	color: var(--racing-green);

	box-shadow: inset 0 -5px 0 rgba(0, 0, 0, 0.24),
		inset -5px 0px 0px rgba(0, 0, 0, 0.24),
		inset 0 5px 0 rgba(255, 255, 255, 0.18),
		inset 5px 0 0 rgba(255, 255, 255, 0.18);

	&::after {
		content: '';
		position: absolute;
		inset: 7px;
		border: 1px solid rgba(0, 0, 0, 0.13);
		pointer-events: none;
	}

	span {
		position: relative;
		z-index: 1;
	}

	&_green {
		background: #21c17e;
	}

	&_yellow {
		background: #e4c47a;
	}

	&_blue {
		background: #4ba3e2;
	}

	&_red {
		background: #c94436;
	}
}

.rule-card__title {
	max-width: 136px;
	margin: 0;
	font-family: var(--font-2);
	font-size: 21px;
	font-weight: 700;
	line-height: 25px;
	color: var(--gray-nurse);
	padding-top: 6px;
}

.rule-card__list {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin: 0;
	padding: 0;
	list-style: none;
}

.rule-card__item {
	display: grid;
	grid-template-columns: 5px minmax(0, 1fr);
	align-items: start;
	gap: 13px;
	margin: 0;
}

.rule-card__bullet {
	align-self: center;
	line-height: 9px;
	&::before {
		content: '▸';
		color: var(--mountain-meadow);
		font-size: 9px;
		line-height: 9px;
	}
}

.rule-card__text {
	font-family: var(--font-1);
	font-size: 15px;
	font-weight: 400;
	line-height: 24px;
	color: var(--edward);
}

/* Warning */

.rules-notice {
	display: flex;
	align-items: flex-start;
	gap: 13px;
	margin-top: 30px;
	padding: 22px 25px;
	background: rgb(228, 196, 122, 0.06);
	border: 1px solid rgb(228, 196, 122, 0.3);
	border-radius: 6px;
}

.rules-notice__text {
	margin: 0;
	font-family: var(--font-1);
	font-size: 14px;
	font-weight: 400;
	line-height: 22px;
	color: #c9b98a;
}

/* Tablet */

@media (max-width: 991.98px) {
	.rules-hero {
		padding-top: 48px;
	}

	.rules-hero__inner,
	.rules-content__inner {
		max-width: 760px;
	}

	.rule-card {
		padding: 25px;
	}
}

/* Mobile */

@media (max-width: 767.98px) {
	.rules-hero {
		padding: 30px 0px 18px;
	}

	.rules-hero__inner {
		gap: 13px;
		padding: 0;
	}

	.rules-hero__back {
		flex-basis: 36px;
		width: 36px;
		height: 36px;
	}

	.rules-hero__back-icon {
		width: 15px;
		height: 15px;
	}

	.rules-hero__subtitle {
		margin-bottom: 10px;
	}

	.rules-hero__description {
		margin-top: 10px;
		font-size: 13px;
		line-height: 20px;
	}

	.rules-content {
		padding: 10px 0px 25px;
	}

	.rules-content__inner {
		padding: 0;
	}

	.rules-list {
		gap: 14px;
	}

	.rule-card {
		padding: 20px;
	}

	.rule-card__header {
		gap: 13px;
		margin-bottom: 15px;
	}

	.rule-card__number {
		flex-basis: 40px;
		width: 40px;
		height: 40px;
		font-size: 11px;
	}

	.rule-card__title {
		font-size: 18px;
		line-height: 21px;
	}

	.rule-card__list {
		gap: 11px;
	}

	.rule-card__text {
		font-size: 13px;
		line-height: 20px;
	}

	.rules-notice {
		margin-top: 20px;
		padding: 17px;
	}

	.rules-notice__text {
		font-size: 12px;
		line-height: 19px;
	}
}

@media (max-width: 480px) {
	.rules-hero__inner {
		display: block;
	}

	.rules-hero__back {
		margin-bottom: 17px;
	}

	.rule-card {
		padding: 17px 15px;
	}

	.rule-card__header {
		align-items: flex-start;
	}

	.rule-card__number {
		flex-basis: 37px;
		width: 37px;
		height: 37px;
	}

	.rule-card__title {
		padding-top: 2px;
		font-size: 17px;
	}

	.rules-notice {
		gap: 10px;
	}
}
</style>
